import { EventPresentation } from './components/EventPresentation';
import { FileFolderPresentation } from './components/FileFolderPresentation';
import { FilePresentation } from './components/FilePresentation';
import { FolderPresentation } from './components/FolderPresentation';
import { ForumPresentation } from './components/ForumPresentation';
import { GroupPresentation } from './components/GroupPresentation';
import { NewsPresentation } from './components/NewsPresentation';
import { PeopleDirectoryPresentation } from './components/PeopleDirectoryPresentation';
import { ProjectPresentation } from './components/ProjectPresentation';
import { TrendingPresentation } from './components/TrendingPresentation';
import { CONTENT_TYPES } from './types';
export const PER_CONTENT_TYPE_COMPONENT = {
    [CONTENT_TYPES.EVENT]: EventPresentation,
    [CONTENT_TYPES.FILE]: FilePresentation,
    [CONTENT_TYPES.FILEFOLDER]: FileFolderPresentation,
    [CONTENT_TYPES.FOLDER]: FolderPresentation,
    [CONTENT_TYPES.FORUM]: ForumPresentation,
    [CONTENT_TYPES.GROUP]: GroupPresentation,
    [CONTENT_TYPES.NEWS]: NewsPresentation,
    [CONTENT_TYPES.PEOPLE_DIRECTORY]: PeopleDirectoryPresentation,
    [CONTENT_TYPES.PROJECT]: ProjectPresentation,
    [CONTENT_TYPES.TRENDING]: TrendingPresentation,
};
//# sourceMappingURL=constants.js.map